import React, { useEffect, useRef } from 'react';
import './css/CircularProgressBlock.css'; // Переиспользуйте стили или создайте новые
import { AChart } from './aChart';
import { formatIntegerWithCommas } from './formatIntegerWithCommas.js';
import { t } from 'ttag';

function TotalAllocationBlock({soldbbk,roundalocatoin,totalbbk}) {

  return (
    <div className="circular-progress-block">
      <div className="circular-progress-header">{t`Total allocation`}</div>
      <AChart series={[soldbbk]} seriest={[totalbbk]} labels={[t`Sold BBK`]} />

      <div className="sold-allocation">
        {t`Round allocation`}
        <span>{formatIntegerWithCommas(roundalocatoin)} BBK</span>
      </div>
    </div>
  );
}

export { TotalAllocationBlock };